import { apiClient } from './api';
import { EnrichedEvent, PagedResponse, EventQueryRequest } from '../types/api';

export const eventsService = {
  getAll: async (params: EventQueryRequest): Promise<PagedResponse<EnrichedEvent>> => {
    const { data } = await apiClient.get('/events', { params });
    return data;
  },

  getById: async (id: number): Promise<EnrichedEvent> => {
    const { data } = await apiClient.get(`/events/${id}`);
    return data;
  },

  getByIp: async (ipAddress: string, page: number = 1, pageSize: number = 50): Promise<PagedResponse<EnrichedEvent>> => {
    const { data } = await apiClient.get(`/events/ip/${ipAddress}`, {
      params: { page, pageSize },
    });
    return data;
  },
};
